import DepositDetail from "../../components/Admin/Deposit/DepositDetail";

const CashierDepositDetail = () => {
  return (
    <section className="w-full">

          <DepositDetail />

    </section>
  )
}
export default CashierDepositDetail


 